import { type CMSLinkUrlDTO, type CMSQuoteDTO } from "../dto";
import { CURRENT_LANGUAGE, DEFAULT_LANGUAGE } from "../../utils/constants";
import { Button } from "~/common/components/Button/Button";

export interface CMSQuoteProps extends Omit<CMSQuoteDTO, "type"> {
  className?: string;
}

export const CMSQuote = (props: CMSQuoteProps) => {
  const url = selectBestUrl(props.linkUrl);

  return (
    <div>
      <div className={"row d-flex flex-wrap"}>
        <div className={"col-12 col-sm-7 col-md-8 scha__cmsquote__quote-div-pl-20"}>
          <span className={"scha__cmsquote__quote-text"}>{props.quote}</span>
        </div>
        <div className={"row col-12 col-sm-5 col-md-4 ml-2 scha__cmsquote__div-image"}>
          <div className={"col-2 col-sm-4 scha__cmsquote__div-min-width"}>
            <img className={"scha__cmsquote__img"} src={props.avatarUrl} />
          </div>
          <div className={"col-5 col-md-7 mt-3"}>
            <div className={"scha__cmsquote__name"}>{props.name}</div>
            <div className={"scha__cmsquote__subtitle"}>{props.subtitle}</div>
          </div>
        </div>
      </div>
      <div className={"row d-flex flex-wrap"}>
        <div className={"col-12 col-sm-2 col-md-2 col-lg-2"}>
          {props.btnLabel != "" && !!url && (
            <Button
              fullWidth={true}
              className={"button scha__teaser__button mt-4"}
              href={url}
              data-test-id={"quote-button-navigation"}
              target={props.target === "newWindow" ? "_blank" : undefined}
            >
              {props.btnLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const selectBestUrl = (links?: CMSLinkUrlDTO[]) => {
  if (!links || links.length === 0) {
    return undefined;
  }

  const findByLng = (lng: string) => (links: CMSLinkUrlDTO[]) =>
    links.find((item) => item.language.toLowerCase() === lng);

  const bestMatch =
    findByLng(CURRENT_LANGUAGE.toLowerCase())(links) ||
    findByLng(DEFAULT_LANGUAGE.toLowerCase())(links) ||
    findByLng("en")(links) ||
    links[0];

  return bestMatch.url;
};
